module.exports = __webpack_public_path__ + "static/media/andhearttrack-logo.35a51d16.svg";